import { getTimezoneOffset } from "date-fns-tz";

import { TimeZoneSettings } from "@/lib/api";

export default class Timezone {
  name: string;
  offset: string;
  label: string;
  tooltip?: string;

  constructor(type = "utc_offset", offset = "+00:00", label = "") {
    this.offset = offset;
    this.name = "UTC";
    this.label = `UTC${offset}`;

    if (type !== "utc_offset") {
      const name = Intl.DateTimeFormat().resolvedOptions().timeZone;
      this.name = name;

      const offsetFromTZ = getTimezoneOffset(name) / (60 * 60 * 1000);
      const minutes = ((offsetFromTZ % 1) * 60).toString().padStart(2, "0");
      const hours = Math.floor(offsetFromTZ).toString().padStart(2, "0");
      const formattedOffset = `${offsetFromTZ < 0 ? "-" : "+"}${hours}:${minutes}`;
      this.offset = formattedOffset;
      const formattedLabel = `${name} (UTC${formattedOffset})`;
      this.label = formattedLabel;
    }

    if (label !== "") {
      this.tooltip = this.label;
      this.label = label;
    }
  }

  static fromSettings(settings: TimeZoneSettings): Timezone;
  static fromSettings(settings: TimeZoneSettings | undefined): Timezone | undefined;
  static fromSettings(settings: TimeZoneSettings | undefined): Timezone | undefined {
    if (!settings) return undefined;
    return new Timezone(
      settings.time_zone_type,
      settings.utc_offset,
      settings.label_override,
    );
  }
}
